// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__rTjpG","head":"Table_head__1ePRd","col":"Table_col__3mKmF"};